import React, { Fragment, useState, useRef, useEffect, useContext } from 'react';
import { Menu, Transition } from '@headlessui/react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import Button from '../buttons/tertiary-button';
import './table.css';
import { NavLink, useLocation } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { Edit, Search, Trash, Trash2 } from 'react-feather';
import { DeleteItem } from "../../utils/functions";
import { useTranslation } from 'react-i18next';
import { HiPlus } from 'react-icons/hi';
import { DataContext } from "../../App";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Table = ({ info }) => {
    const { t } = useTranslation();
    const context = useContext(DataContext);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [deleteCollectionDialog, setDeleteCollectionDialog] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const dt = useRef(null);
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 10 });
    const location = useLocation();
    const currentPath = location.pathname;


    let newPath;
    if (currentPath.includes('users')) {
        newPath = "/admin/users/create";
    } else if (currentPath.includes('properties-collection')) {
        newPath = "/admin/properties-collection/create";
    } else if (currentPath.includes('experiences')) {
        newPath = "/admin/experiences/create";
    } else if (currentPath.includes('categories')) {
        newPath = "/admin/categories/create";
    }
    //default
    else {
        newPath = "/admin/properties-collection/create";
    }

    function closeModal() {
        setDeleteCollectionDialog(false);
    }

    useEffect(() => {
        // loadLazyData();
    }, [lazyParams, selectedItems]);


    const confirmDeleteSelected = () => {
        setDeleteCollectionDialog(true);

    };

    const ActionBodyTemplate = (rowData) => {
        return (
            <div className="d-flex justify-content-end">
                <NavLink
                    className="block w-full px-2 py-2 me-2 text-center linkTable text-black"
                    to={`/admin/${info.url.toLowerCase()}/update?id=${rowData.id ? rowData.id : rowData.uid ? rowData.uid : ""}`}
                    state={{ itemState: rowData.id ? rowData.id : rowData.uid ? rowData.uid : "" }}
                >
                    <Edit size={18} />
                </NavLink>

                <button
                    className="button-dropdown block px-2 py-2 linkTable"
                    onClick={() => {
                        setSelectedItemId(rowData.id ? rowData.id : rowData.uid ? rowData.uid : "");
                        confirmDeleteSelected();
                    }}
                >
                    <Trash2 size={18} />
                </button>
            </div>

        );
    };

    const header = (
        <div className="row header-search py-1">
            <div className="col-lg-6 col-12">
            <div className="flex d-flex align-items-center">
                <div className="mt-2">

                    <NavLink
                        to={newPath}
                        className={"admin-button"}
                    >
                        <HiPlus className="fs-6 mb-1 me-2" />{t("AddNew")}
                    </NavLink>

                </div>
            </div>
            </div>
            <div className="col-lg-3 offset-lg-3 col-12 mt-5 mt-lg-0">
            <div className="d-flex align-items-center justify-content-between py-1 ml-4 pe-3 searchAdmin">
                <IconField iconPosition="left" className="d-flex w-100">
                    <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder={t("Search")}

                    />
                    <Search className="ms-auto mt-2 me-2" />
                </IconField>
            </div>
            </div>
        </div>
    );

    const customBodyTemplate = (rowData, column) => {

        const row = rowData;
        const field = column.field;
        let fieldValue = "";
        if (field.includes(".")) {
            const dataSplitted = field.split('.');
            fieldValue = row[dataSplitted[0]] && row[dataSplitted[0]][dataSplitted[1]] !== null ? row[dataSplitted[0]][dataSplitted[1]] : "";
        }
        else if (field === "descriptions") {
            if (row.descriptions && Array.isArray(row.descriptions)) {
                const titles = row.descriptions.map(desc => desc.title).filter(title => title).join(", ");
                fieldValue = titles;
            } else {
                fieldValue = "";
            }
        }
        else if (field === "seoInformation") {
            if (row.seoInformation) {
                let keywords = "";
                if (row.seoInformation.keywords) {
                    keywords = row.seoInformation.keywords.join(", ");
                }
                fieldValue = `${row.seoInformation.title || ""} | ${row.seoInformation.metaDescription || ""} | ${keywords}`.trim();
            } else {
                fieldValue = "";
            }
        }
        else if (field === "disabled") {
            if (row.disabled) {
                fieldValue = t("Inactive");
            } else {
                fieldValue = t("Active");
            }
        }
        else {
            fieldValue = row[column.field];
        }


        const fieldSymbol = column.symbol;
        if (fieldValue && fieldValue instanceof Date) {
            let date = new Date(fieldValue._seconds * 1000);
            let dateString = date.toLocaleDateString();
            fieldValue = dateString;
        }
        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: fieldValue }}></div>
                {fieldSymbol && ` ${fieldSymbol}`}
            </>
        );
    };

    return (
        <div className={"table-wrapper"}>
            <DataTable
                emptyMessage={"No available options"}
                ref={dt}
                value={info.body}
                selection={selectedItems}
                onSelectionChange={(e) => setSelectedItems(e.value)}
                dragSelection
                dataKey="id"
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="RowsPerPageDropdown PrevPageLink CurrentPageReport NextPageLink"
                currentPageReportTemplate={`{first} to {last} of {totalRecords}`}
                globalFilter={globalFilter}
                header={header}
                selectionMode="single"

            >
                {info.header.map((col) => (
                    <Column key={col.field} field={col.field} header={col.header} sortable={col.sortable} body={(rowData) => customBodyTemplate(rowData, col)} />
                ))}
                <Column body={ActionBodyTemplate} exportable={false} />
            </DataTable>

            {deleteCollectionDialog && (
                <Dialog draggable={false} className={"dialog-delete-table"} visible={deleteCollectionDialog} onHide={() => { if (!deleteCollectionDialog) return; setDeleteCollectionDialog(false); }}>

                    <div className="d-flex flex-column text-center h-100">
                        <h4 className="pb-5 mt-3">{t("AreYouSureToDelete")}</h4>
                        <div className="d-flex justify-content-around mt-auto">
                            <Button
                                id={"deleteSelectedItems"}
                                className={"btn btn-danger br-0"}
                                onClick={() => DeleteItem(info.name, selectedItemId).then(() => closeModal()).then(async () => await context.updateData(info.url))}
                                content={"Delete"}
                                isDisabled={false}
                            />
                        </div>
                    </div>
                </Dialog>

            )}
        </div>
    );
}

export default Table;